// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import CardView from '@/views/CardView.vue'
import CollectionView from '@/views/CollectionView.vue'
import MarketSection from '@/components/MarketSection.vue'

const routes = [
  { path: '/market', name: 'Market', component: MarketSection, props: { full: true }, meta: { bodyClass: 'market' } },
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
    meta: { bodyClass: 'home' }
  },
  {
    path: '/collection',
    name: 'Collection',
    component: CollectionView,
    meta: { bodyClass: 'collection' }
  },
  {
    path: '/card/:id',
    name: 'CardView',
    component: CardView,
    props: true,
    meta: { bodyClass: 'card-view' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.path === '/collection' && from.path === to.path && !to.hash) return { el: '#collection-filters', top: 16 };
    if (to.hash) return { el: to.hash, top: 24 };
    return { top: 0 };
  }
})

export default router
